import { NotificationRenderer } from '@filament/react/notification';
import { Portal } from '@filament/utils-react';
import { animated, useSpring } from '@react-spring/web';
import { Suspense, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { ErrorBoundary, Loading, PageError } from '@/shared/ui';
import * as styles from './Layout.css';
import { SideNavBar } from './ui/SideNavBar/SideNavBar';
import { TopNavBar } from './ui/TopNavBar/TopNavBar';

export const Layout = () => {
    const location = useLocation()
    const [isSidebarOpen, setIsSidebarOpen] = useState(true);
    const animateConfig = {
        tension: 600,
        friction: 60,
    }

    const animatePanel = useSpring({
        config: animateConfig,
        from: { overflow: 'hidden' },
        to: {
            marginInlineStart: isSidebarOpen ? '0rem' : '-20rem',
            paddingInlineEnd: isSidebarOpen ? '0rem' : '0.5rem',
            width: '20rem',
        }
    });

    return (
        <div className={styles.layout}>
            <NotificationRenderer variant="toast" placement="topRight" style={{ zIndex: 9999 }} />

            <Portal>
                <TopNavBar onSidebarToggle={() => setIsSidebarOpen(!isSidebarOpen)} />
                <div className={styles.container}>
                    <animated.aside style={animatePanel}>
                        <SideNavBar isOpen={isSidebarOpen} animateConfig={animateConfig} />
                    </animated.aside>

                    <main id="main" className={styles.main}>
                        <ErrorBoundary
                            key={location.pathname}
                            fallback={(error) => <PageError error={error} />}
                        >
                            <Suspense fallback={<Loading text="Loading page..." />}>
                                <Outlet />
                            </Suspense>
                        </ErrorBoundary>
                    </main>
                </div>
            </Portal>
        </div >
    )
}
